
import React, { createContext, useState, useContext, useEffect } from 'react';
import { MyContext } from './ProviderContext';

export const Contact = () => {

    const { menuComponent, setMenuComponent } = useContext(MyContext);
    useEffect(() => {
        setMenuComponent({ home: '', about: '', services: '', team: '', contact: 'active', project: '' });
    }, [])

    return (
        <>

            <div className="page-header contact" >
                <div className="container">
                    <div className="row">
                        <div className="col-12">
                            <h2>Contact Us</h2>
                        </div>
                        <div className="col-12">
                            <a href="">Home</a>
                            <a href="">Contact Us</a>
                        </div>
                    </div>
                </div>
            </div>

            <div className="contact wow fadeInUp">
                <div className="container">
                    <div className="section-header text-center">
                        <p>Get In Touch</p>
                        <h2>For Any Query</h2>
                    </div>
                    <div className="row">
                        <div className="col-md-6">
                            <div className="contact-info">
                                <div className="contact-item">
                                    <i className="flaticon-address"></i>
                                    <div className="contact-text">
                                        <h2>Frantino Multiple Services Limited</h2>
                                        <p>Plot 185 Mercy Lane Federal Housing Authority Estate off Peter Odili Road, Trans-Amadi Port Harcourt, Rivers State Nigeria.</p>
                                        <div className="contact-text">
                                            <p><i className="flaticon-call"></i> +234 806 222 1110</p>
                                            <p><i className="flaticon-send-mail"></i> info@frantinoservices.com</p>
                                            <p>www.frantinoservices.com</p>
                                        </div>
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <i className="flaticon-address"></i>
                                    <div className="contact-text">
                                        <h2>U.S.A. Branch Office</h2>
                                        <p>19303 Arrow Grand CT Richmond, Texas TX 77407 United States of America</p>
                                        <div className="contact-text">
                                            <p><i className="flaticon-call"></i> +1 (850) 988 5399</p>

                                        </div>
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <i className="flaticon-address"></i>
                                    <div className="contact-text">
                                        <h2>U.A.E. Branch Office</h2>
                                        <p>A.E. Branch Office Sharjah Media City Sharjah United Arab Emirates</p>
                                        <div className="contact-text">
                                            <p><i className="flaticon-call"></i> +971 52 776 7400</p>

                                        </div>
                                    </div>
                                </div>
                                <div className="contact-item">
                                    <i className="flaticon-address"></i>
                                    <div className="contact-text">
                                        <h2>Fabrication/Plant Yard</h2>
                                        <p>3 Stanley Close, off Ring Road Okwuzi-Egbema, ONELGA Rivers State, Nigeria.</p>
                                        <div className="contact-text">
                                            <p><i className="flaticon-call"></i> +234 809 111 4926</p>

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="col-md-6">
                            <div className="contact-form">
                                <div id="success"></div>
                                <form name="sentMessage" id="contactForm" novalidate="novalidate">
                                    <div className="control-group">
                                        <input type="text" className="form-control" id="name" placeholder="Your Name" required="required" data-validation-required-message="Please enter your name" />
                                        <p className="help-block text-danger"></p>
                                    </div>
                                    <div className="control-group">
                                        <input type="email" className="form-control" id="email" placeholder="Your Email" required="required" data-validation-required-message="Please enter your email" />
                                        <p className="help-block text-danger"></p>
                                    </div>
                                    <div className="control-group">
                                        <input type="text" className="form-control" id="subject" placeholder="Subject" required="required" data-validation-required-message="Please enter a subject" />
                                        <p className="help-block text-danger"></p>
                                    </div>
                                    <div className="control-group">
                                        <textarea className="form-control" id="message" placeholder="Message" required="required" data-validation-required-message="Please enter your message"></textarea>
                                        <p className="help-block text-danger"></p>
                                    </div>
                                    <div>
                                        <button className="btn" type="submit" id="sendMessageButton">Send Message</button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d31806.76161969983!2d7.021171667222378!3d4.796611691431612!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x1069cc5d0a084dab%3A0x49cbcc4d852f9cf0!2sFRANTINO%20MULTIPLE%20SERVICES%20LIMITED!5e0!3m2!1sfr!2sfr!4v1738772179658!5m2!1sfr!2sfr" width="100%" height="450" style={{ "border": 0 }} allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        </>

    )
}